<template>
  <section class="slide-section">
    <Header></Header>
    <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
    <label class="verticalLabel right reportTitle">Key Milestones</label> -->
    <div class="glanceHeading">key figures</div>
    <div class="sliderWrapper">
        <div class="container">
          <VueSlickCarousel v-bind="sliderSettingsBg" ref="carousel" @beforeChange="onbeforeCarousel" @init="onInitCarousel"
           @afterChange="onAfterChange" class="main-slider">
            <div class="child-slider first-slide">
              <div class="under-content">
                  <div class="main-content">
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 160.131 160.246"
                        >
                          <use xlink:href="#profileIcon"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              ref="number1"
                              :from="0"
                              :to="47.8"
                              :format="theFormat"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5 class="span">MILLION</h5>
                          <small>ACTIVE CUSTOMERS</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 160.246 160.246"
                        >
                          <use xlink:href="#economic-investment"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="5.3"
                              :format="theFormat_doller"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5 class="span">BILLION</h5>
                          <small>IN REVENUES</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 160.246 160.246"
                        >
                          <use xlink:href="#economic-investment"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="605"
                              :format="theFormat_doller_noFixed"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5 class="span">MILLION</h5>
                          <small>IN NET INCOME</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content fourth-slide">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="179.867"
                          height="183.537"
                          viewBox="0 0 179.867 183.537"
                        >
                          <defs>
                            <linearGradient
                              id="linear-gradient"
                              x1="0.5"
                              x2="0.5"
                              y2="1"
                              gradientUnits="objectBoundingBox"
                            >
                              <stop offset="0" stop-color="#dedede" />
                              <stop offset="1" stop-color="#fff" />
                            </linearGradient>
                          </defs>
                          <g
                            id="noun_chart_2500546"
                            transform="translate(-3.499 -2.5)"
                          >
                            <g
                              id="Group_35"
                              data-name="Group 35"
                              transform="translate(3.5 2.5)"
                            >
                              <path
                                id="Path_7"
                                data-name="Path 7"
                                d="M41.8,75.8H14.562A6.845,6.845,0,0,0,7.8,82.562v28.4a6.845,6.845,0,0,0,6.762,6.762H41.8a6.845,6.845,0,0,0,6.762-6.762v-28.4A6.845,6.845,0,0,0,41.8,75.8Z"
                                transform="translate(0.507 65.813)"
                                fill="url(#linear-gradient)"
                              />
                              <path
                                id="Path_8"
                                data-name="Path 8"
                                d="M73.6,61.7H46.162A6.845,6.845,0,0,0,39.4,68.462V124.1a6.845,6.845,0,0,0,6.762,6.762H73.4a6.845,6.845,0,0,0,6.762-6.762V68.462A6.558,6.558,0,0,0,73.6,61.7Z"
                                transform="translate(29.958 52.672)"
                                fill="url(#linear-gradient)"
                              />
                              <path
                                id="Path_9"
                                data-name="Path 9"
                                d="M105.1,47.7H77.862A6.845,6.845,0,0,0,71.1,54.462V137.15a6.845,6.845,0,0,0,6.762,6.762H105.1a6.845,6.845,0,0,0,6.762-6.762V54.462A6.6,6.6,0,0,0,105.1,47.7Z"
                                transform="translate(59.501 39.625)"
                                fill="url(#linear-gradient)"
                              />
                              <path
                                id="Path_10"
                                data-name="Path 10"
                                d="M161.148,2.5a22.194,22.194,0,0,0-20.672,30.332L105.7,66.255,87.154,46.935a9.572,9.572,0,0,0-5.989-2.7,8.639,8.639,0,0,0-5.989,2.318L34.6,85.575a22.921,22.921,0,0,0-8.887-1.932,22.218,22.218,0,1,0,22.222,22.219,22.455,22.455,0,0,0-1.546-8.116l34.389-33.23,18.547,19.32a9.572,9.572,0,0,0,5.989,2.7,8.639,8.639,0,0,0,5.989-2.318L152.261,44.81a22.921,22.921,0,0,0,8.887,1.932,22.346,22.346,0,0,0,22.218-22.218A22.18,22.18,0,0,0,161.148,2.5ZM25.524,114.747a8.658,8.658,0,1,1,6.158-2.536,8.694,8.694,0,0,1-6.158,2.536ZM161.148,33.411a8.694,8.694,0,1,1,8.694-8.694,8.782,8.782,0,0,1-8.694,8.694Z"
                                transform="translate(-3.5 -2.5)"
                                fill="#ffff0a"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="14"
                              :format="theFormat_noFixed"
                              :duration="1.5"
                              @complete="complete"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5 class="span">CENT</h5>
                          <small>In EPS</small>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="child-slider second-slide">
              <div class="under-content">
                  <div class="main-content">
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 137.695 131.314"
                        >
                          <use xlink:href="#worldIcons"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="16220"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5>TB</h5>
                          <small>Average Daily<br />Data Volume</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 131.724 131.534"
                        >
                          <use xlink:href="#circleChart"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5>MARKET LEADER</h5>
                          <small
                            >IN KUWAIT, IRAQ, <br />SUDAN AND JORDAN</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 181.516 146.273"
                        >
                          <use xlink:href="#arrowChart"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="2.0"
                              :format="theFormat"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <h5>X</h5>
                          <small>IN NET DEBT/EBITDA</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.228 160.003"
                        >
                          <use xlink:href="#five_g"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5>5G TECHNOLOGY</h5>
                          <small>IN KUWAIT, KSA <br/> AND BAHRAIN</small>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="child-slider third-slide">
              <div class="under-content">
                  <div class="main-content">
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 181.516 146.273"
                        >
                          <use xlink:href="#arrowChart"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="2.2"
                              :format="theFormat_doller"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5>BILLION</h5>
                          <small>IN EBITDA<br />EBITDA MARGIN 41%</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 163 140.675"
                        >
                          <use xlink:href="#lineChart"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="1.4"
                              :format="theFormat_doller"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <h5>BILLION</h5>
                          <small>IN CAPEX<br />26% OF REVENUE</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top nationalities">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 116.301 145.99"
                        >
                          <use xlink:href="#passport"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                          <number
                              v-if="reRender"
                              :from="0"
                              :to="45"
                              :format="theFormat_noFixed"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <small>Nationalities</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 160.26 148.759"
                        >
                          <use xlink:href="#girlsIcons"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="27"
                              :format="theFormat_percentage_noFixed"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <small>FEMALE<br/>EMPLOYEES</small>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="child-slider fourth-slide">
              <div class="under-content">
                  <div class="main-content">
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 150.957 140"
                        >
                          <use xlink:href="#mblIcon"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="9"
                              :format="theFormat_percentage_noFixed"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <small>DATA REVENUE<br/>GROWTH</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 173.063 108.591"
                        >
                          <use xlink:href="#employes"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">OVER</h5>
                          <h5 class="counter">
                            <number
                              v-if="reRender"
                              :from="0"
                              :to="7500"
                              :duration="1.5"
                              easing="Power1.easeOut"
                            />
                          </h5>
                          <br>
                          <small>EMPLOYEES</small>
                        </div>
                      </div>
                    </div>
                    <div class="slides-content">
                      <div class="img-top">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 137.695 131.314"
                        >
                          <use xlink:href="#worldIcons"></use>
                        </svg>
                      </div>
                      <div class="text-count">
                        <div class="text-container">
                          <h5 class="counter">FREE DATA AND<br />VOICE TO 2.5m</h5>
                          <small>CUSTOMERS DURING <br />THE LOCKDOWN PERIOD</small>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
export default {
  components: {
    VueSlickCarousel,
  },
  // mounted() {
  //   document.body.classList.add("no-scroll");
  // },
  data() {
    return {
      reRender: true,
      sliderSettingsBg: {
        slidesToShow: 1,
        slideToScroll: 1,
        dots: true,
        arrows:true,
        cssEase: "cubic-bezier(0.670, 0.965, 1.000, 1.000)",
        speed: 800,
        infinite: false,
        loop:true,
        focusOnSelect: true,
        swipeToSlide: true,
        prevArrow: this.$refs.prevous,
        nextArrow: this.$refs.next,
      },
    };
  },
  methods: {
    numberWithCommas(n) {
      var parts = n.toString().split(".");
      return (
        parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (parts[1] ? "." + parts[1] : "")
      );
    },
    theFormat_comma(number) {
      return this.numberWithCommas(number);
    },
    theFormat_fixed_three(number) {
      return number.toFixed(3);
    },
    theFormat(number) {
      return number.toFixed(1);
    },
    theFormat_noFixed(number) {
      return number.toFixed(0);
    },
    theFormat_doller(number) {
      return "$" + number.toFixed(1);
    },
    theFormat_doller_noFixed(number) {
      return "$" + number.toFixed(0);
    },
    theFormat_percentage(number) {
      return number.toFixed(1) + "%";
    },
    theFormat_percentage_noFixed(number) {
      return number.toFixed(0) + "%";
    },
    onbeforeCarousel() {
      this.reRender = false;
      setTimeout(() => {
        this.reRender = true;
      }, 100);
    },
    onInitCarousel() {
      // this.reRender = true
      // this.$refs.number1.restart()
    },
    onAfterChange() {
      // this.$refs.number1.restart()
    },
    complete() {},
    slidePrev() {
      this.$refs.carousel.prev();
    },
    slideNext() {
      this.$refs.carousel.next();
    },
  },
};
</script>
<style lang="scss" scoped>
    @import "@/assets/sccs/glance.scss";
</style>
